<template>
  <div
    id="campaigns"
    class="content"
  >
    <div id="content">
      <div class="container">
        <h1
          v-if="isAdmin[0]"
          class="page-title"
        >
          <i class="fal fa-suitcase"></i> Campagnes
        </h1>
        <h1
          v-else
          class="page-title"
        >
          <i class="fal fa-suitcase"></i> Mes Campagnes
        </h1>
        <div
          class="info-button"
          @click.stop="$parent.toggleInfo"
        >
          <i class="fal fa-info-circle"></i> {{$parent.info_visible ? "Masquer les informations" : "Voir les informations"}} </div>
      </div>
      <div
        class="page-description"
        :class="{hidden: !$parent.info_visible}"
      >
        <b-message
          v-if="isAdmin[0]"
          type="is-primary"
        >
          <i class="fal fa-info-circle"></i>
          Pour <strong>saisir</strong> une nouvelle Campagne, cliquez sur "<strong><i class="far fa-plus-circle"></i> Ajouter une Campagne"</strong>, puis remplissez la totalité des champs.
          <br>
          Pour <strong>modifier</strong> les différentes entrées de la liste, sélectionnez un champ puis modifiez le.
          <br>
          Pour <strong>supprimer</strong> des Campagnes, cochez les lignes puis cliquez sur le bouton <strong>"Supprimer"</strong>.
        </b-message>
        <b-message
          v-if="(!isAdmin[0])"
          type="is-primary"
        >
          <i class="fal fa-info-circle"></i>
          En tant que superviseur, vous pouvez visionner, mais pas modifier les Campagnes.
          <br>
          Vous pouvez cependant créer et supprimer des <strong>Sous-Campagnes</strong>.
          <br>
          Pour <strong>modifier</strong> les différentes entrées de la liste, faites appel à un Administrateur.
        </b-message>
      </div>
    </div>

    <campaignsTable
      id="campaignsTable"
      :campaigns="campaigns"
      :isComponentModalActive="isComponentModalActive"
      :isAddNewSubCampaignModalActive="isAddNewSubCampaignModalActive"
      :isAdmin="isAdmin"
    />

  </div>
</template>

<script>
import campaignsTable from "@/components/campaignsTable";
import _ from "lodash";

import http from "@/modules/request";

export default {
  name: "campaigns",
  components: {
    campaignsTable
  },
  data() {
    return {
      isAddDisplayed: false,
      campaigns: [],
      campaignId: "",
      campaign_sales_goal: "",
      start_date: "",
      end_date: "",
      name: "",
      isComponentModalActive: false,
      isAddNewSubCampaignModalActive: false,
      isDeleteSubCampaignConfirmationModalActive: false,
      isDeleteConfirmationModalActive: false,
      isAdmin: [undefined, undefined]
    };
  },
  mounted() {
    this.getCampaigns();
    this.isAdmin = [
      this.$store.state.role == "admin",
      this.$store.state.weezy_id
    ];
  },
  methods: {
    getCampaigns(reformat = true) {
      http
        .get("/campaigns")
        .then(response => {
          var dataCampaigns = response.data;
          if (reformat) {
            for (var i = 0; i < dataCampaigns.length; i++) {
              //Convert Data to date
              dataCampaigns[i].start_date = new Date(
                dataCampaigns[i].start_date
              );
              dataCampaigns[i].end_date = new Date(dataCampaigns[i].end_date);
            }
            this.campaigns = dataCampaigns;
          }
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
          this.errorToast("Échec de récupération des Campagnes");
        });
    },
    showAdd: function() {
      this.isAddDisplayed = true;
      this.isModifyDisplayed = false;
      this.clearFields();
      setTimeout(() => {
        window.scrollTo(
          0,
          document.body.scrollHeight || document.documentElement.scrollHeight
        );
      }, 10);
    },
    scrollToBottom() {
      setTimeout(() => {
        window.scrollTo(
          0,
          document.body.scrollHeight || document.documentElement.scrollHeight
        );
      }, 1000);
    },
    hideAdd: function() {
      this.isAddDisplayed = false;
    },
    submitAdd: function() {
      http
        .post("/campaigns", {
          campaign: {
            name: this.name,
            start_date: this.start_date,
            end_date: this.end_date,
            campaign_sales_goal: this.campaign_sales_goal
          }
        })
        .then(
          function(response) {
            var dataCampaigns = response.data;
            for (var i = 0; i < dataCampaigns.length; i++) {
              //Convert Data to date
              dataCampaigns[i].start_date = new Date(
                dataCampaigns[i].start_date
              );
              dataCampaigns[i].end_date = new Date(dataCampaigns[i].end_date);
            }
            this.campaigns = dataCampaigns;
            this.isComponentModalActive = false;
            this.succesToast("Campagne ajoutée avec succès");
          }.bind(this)
        )
        .catch(function(error) {
          console.log("error (normal) :" + error);
          console.log("error (as JSON) :" + JSON.stringify(error));
          this.errorToast("Échec d'ajout de la Campagne");
        });
    },
    submitAddNewSubCampaign() {
      http
        .post("/subcampaigns", {
          sub_campaign: {
            campaign_id: this.add_new_sub_campaign_to,
            name: this.new_sub_campaign_name
          }
        })
        .then(
          function(response) {
            this.isAddNewSubCampaignModalActive = false;
            this.campaigns = response.data;
            this.succesToast("Sous-Campagne ajoutée avec succès");
          }.bind(this)
        )
        .catch(function(error) {
          console.log("error (normal) :" + error);
          console.log("error (as JSON) :" + JSON.stringify(error));
          this.errorToast("Échec d'ajout de la Sous-Campagne");
        });
    },
    submitModify: function() {
      http
        .patch("/campaigns/" + this.campaignId, {
          campaign: {
            name: this.name,
            start_date: this.start_date,
            end_date: this.end_date,
            campaign_sales_goal: this.campaign_sales_goal
          }
        })
        .then(
          function(response) {
            this.getCampaigns(false);
            this.debounceNotif();
          }.bind(this)
        )
        .catch(function(error) {
          console.log("error (normal) :" + error);
          console.log("error (as JSON) :" + JSON.stringify(error));
          this.errorToast("Échec de modification");
        });
    },

    debounceNotif: _.debounce(async function(e) {
      this.succesToast("Campagne(s) modifiée(s) avec succès");
    }, 1000),

    submitDelete: function() {
      http
        .delete("/campaigns/" + this.campaignId)
        .then(
          function(response) {
            this.getCampaigns();
            this.succesToast("Campagne(s) supprimée(s) avec succès");
            this.isDeleteConfirmationModalActive = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            console.log("error (normal) :" + error);
            console.log("error (as JSON) :" + JSON.stringify(error));
            this.errorToast(
              "Échec de suppression. Avez-vous supprimé les éléments liés à cette campagne ?"
            );
          }.bind(this)
        );
    },
    clearFields: function() {
      this.campaignId = "";
      this.name = "";
      this.start_date = "";
      this.end_date = "";
      this.campaign_sales_goal = "";
    },
    dateFormatter(value) {
      var date = new Date(value);
      var years = date.getFullYear();
      var months = this.leadZero(date.getMonth() + 1); // +1 because Jan is 0 !
      var days = this.leadZero(date.getDate());
      return years + "-" + months + "-" + days;
    },
    leadZero(n) {
      return n > 9 ? n : "0" + n;
    },
    modifyRows(rows) {
      var count = rows.length;
      var modifiedArray = [];
      // From latest to oldest
      for (var i = 0; i < count; i++) {
        var modified = rows[count - i - 1];
        if (!modifiedArray.includes(modified.id)) {
          modifiedArray.push(modified.id);
          this.campaignId = modified.id;
          this.name = modified.name;
          this.start_date = this.dateFormatter(modified.start_date);
          this.end_date = this.dateFormatter(modified.end_date);
          this.campaign_sales_goal = modified.campaign_sales_goal;
          if (this.name == "" || this.campaign_sales_goal == "") {
            this.errorToast("Merci de remplir tous les champs");
            this.getCampaigns();
          } else {
            this.submitModify();
          }
        }
      }
    },
    addNewRow(rows) {
      this.name = rows.name;
      this.start_date = this.dateFormatter(rows.start_date);
      this.end_date = this.dateFormatter(rows.end_date);
      this.campaign_sales_goal = rows.campaign_sales_goal;
      this.submitAdd();
    },
    addNewSubCampaign(sub_campaign) {
      (this.new_sub_campaign_name = sub_campaign.name),
        (this.add_new_sub_campaign_to = sub_campaign.campaign_id);
      this.submitAddNewSubCampaign();
    },
    deleteSubCampaign(sub_campaign) {
      http
        .delete("/subcampaigns/" + sub_campaign)
        .then(
          function(response) {
            this.campaigns = response.data;
            this.succesToast("Sous-Campagne supprimée avec succès");
            this.isDeleteSubCampaignConfirmationModalActive = false;
          }.bind(this)
        )
        .catch(function(error) {
          console.log("error (normal) :" + error);
          console.log("error (as JSON) :" + JSON.stringify(error));
          this.errorToast("Échec de suppression");
        })
        .bind(this);
    },
    deleteCheckedRows(checkedCampaigns) {
      var count = checkedCampaigns.length;
      for (var i = 0; i < count; i++) {
        this.campaignId = checkedCampaigns[i].id;
        this.submitDelete();
      }
    },

    errorToast(message) {
      this.$toast.open({
        duration: 5000,
        message: message,
        position: "is-bottom",
        type: "is-danger"
      });
    },
    succesToast(message) {
      this.$toast.open({
        duration: 2000,
        message: message,
        position: "is-bottom",
        type: "is-success"
      });
    }
  }
};
</script>

<style scoped>
.content {
  background-color: #ffffff;
}

.add-campaign {
  width: auto;
  padding-top: 40px;
  padding-left: 30px;
}
</style>